import Type from "typebox";
import { NonogramSchema } from "./nonogram.js";
export const GetNonogramsResponseSchema = Type.Object({
    nonograms: Type.Array(NonogramSchema)
});
